<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmPopup key="popup"></p-confirmPopup>
<p-tieredMenu  #menuContextuelItemCommande popup="popup" autoDisplay [model]="menuContextuelEntrees"></p-tieredMenu >
<p-menu #menuContextuelActionsMultiples popup="popup" [model]="menuContextuelActionsMultiplesItems"></p-menu>

<p-confirmDialog #confirmDialogAjoutRequisition0Items header="Confirmation" key="ajoutRequisition0Items"
	icon="pi pi-exclamation-triangle">
	<ng-template pTemplate="headless">
		<div class="m-4">
			<div class="text-500">Veuillez sélectionner au moins un item prêt ou chargé</div>
		</div>
		<div class="flex justify-content-center mb-4">
			<button pButton type="button" label="OK" (click)="confirmDialogAjoutRequisition0Items.hide()"
				class="p-button-success"></button>
		</div>
	</ng-template>
</p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()">
	<div>
		<p-card>
			<h5>
				Administration des commandes (<span *ngIf="emplacement() && emplacement().length > 0" class="text-500">
					@for (emplacement of emplacement(); track emplacement.emplacementId) {
						<i class="pi pi-map-marker ml-1"></i> {{emplacement.nom}}
					}
				</span>
				<span *ngIf="!emplacement() || emplacement().length === 0" class="text-500">Tous les emplacements</span>)
			</h5>

			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>

		</p-card>
	</div>
</div>

<!-- Dashboard Statistics Cards -->
<div *ngIf="EstCharge() && showStats()" class="grid mt-1">
	<!-- Card 1: User's Commands -->
	<div class="col-12 md:col-6 lg:col-3 pb-0">
		<p-card styleClass="h-full">
			<div class="flex justify-content-between">
				<div>
					<div class="text-500 font-medium mb-2">Mes Commandes</div>
					<div class="text-900 font-medium text-xl">{{nbItemsCommandePourUtilisateurCourant()}}</div>
					<div class="text-500 text-sm mt-2">
						<button *ngIf="!voirMesCommandes() && nbItemsCommandePourUtilisateurCourant() > 0" pButton
							type="button" label="Voir les commandes de  {{profilService.ProfilCourant() | nomEmploye}}"
							class="p-button-text p-button-sm p-0" (click)="voirMesCommandes.set(true)"></button>
						<button *ngIf="voirMesCommandes()" pButton type="button" label="Réinitialiser"
							class="p-button-text p-button-sm p-0" (click)="voirMesCommandes.set(false)"></button>
					</div>
				</div>
				<div class="flex align-items-center justify-content-center bg-blue-100 border-round"
					style="width: 2.5rem; height: 2.5rem">
					<i class="pi pi-user text-blue-500 text-xl"></i>
				</div>
			</div>
		</p-card>
	</div>

	<!-- Card 2: Status Distribution -->
	<div class="col-12 md:col-6 lg:col-3 pb-0">
		<p-card styleClass="h-full">
			<div class="flex justify-content-between gap-2">
				<div class="flex-1">
					<div class="text-500 flex flex-wrap gap-4">
						<div *ngFor="let stat of statsParStatut(); let i = index" class="mx-2">
							<div class="flex align-items-center gap-1">
								<span [class]="'statut ' + getStatutCssClass(stat.statutNom)">{{stat.statutNom}}</span>
								<span class="font-semibold">{{stat.count}}</span>
							</div>
						</div>
						<div *ngIf="statsParStatut().length === 0" class="col-12">Aucune donnée</div>
					</div>
					<div class="text-500 text-sm m-2">Total: {{itemsCommande().length}}</div>
				</div>
				<div class="flex align-items-center justify-content-center bg-green-100 border-round"
					style="width: 2.5rem; height: 2.5rem">
					<i class="pi pi-chart-bar text-green-500 text-xl"></i>
				</div>
			</div>
		</p-card>
	</div>

	<!-- Card 3: Recent Activity -->
	<div class="col-12 md:col-6 lg:col-3 pb-0" [class.activity-card-updating]="activiteEnCoursDeMAJ()">
		<p-card styleClass="h-full">
			<div class="flex justify-content-between">
				<div class="flex-1">
					<div class="text-500 font-medium mb-2">Activité Récente</div>
					<div *ngIf="derniereActivite(); else noActivity">
						<div class="text-900 font-medium text-xl mb-1" [title]="derniereActivite()?.titre">
							{{derniereActivite()?.titre || 'Activité'}}
						</div>
						<div class="text-500 text-sm" *ngIf="derniereActivite()?.description"
							[title]="derniereActivite()?.description">
							{{derniereActivite()?.description}}
						</div>
						<div class="text-500 text-sm mt-1" *ngIf="derniereActivite()?.employe">
							Par {{derniereActivite()?.employe?.prenom}} {{derniereActivite()?.employe?.nom}}
						</div>
						<div class="text-500 text-sm">
							{{derniereActivite()?.date | date:'short'}}
						</div>
					</div>
					<ng-template #noActivity>
						<div class="text-900 font-medium text-xl">Aucune activité</div>
						<div class="text-500 text-sm mt-2">Pas d'activité récente</div>
					</ng-template>
				</div>
				<div class="flex align-items-center justify-content-center bg-blue-100 border-round"
					style="width: 2.5rem; height: 2.5rem">
					<i class="pi pi-history text-blue-500 text-xl"
						[class.activity-icon-updating]="activiteEnCoursDeMAJ()"></i>
				</div>
			</div>
		</p-card>
	</div>

	<!-- Card 4: Overdue Orders -->
	<div class="col-12 md:col-6 lg:col-3 pb-0">
		<p-card styleClass="h-full">
			<div class="flex justify-content-between">
				<div>
					<div class="text-500 font-medium mb-2">En Retard</div>
					<div class="text-900 font-medium text-xl">{{nombreCommandesEnRetard()}}</div>
					<div class="text-500 text-sm mt-2">Commandes échues</div>
				</div>
				<div class="flex align-items-center justify-content-center bg-red-100 border-round"
					style="width: 2.5rem; height: 2.5rem">
					<i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
				</div>
			</div>
		</p-card>
	</div>
</div>

<div *ngIf="EstCharge()" class="w-full">
	<div class="flex justify-content-center">
		<p-button *ngIf="!showStats()" icon="pi pi-chevron-down" (onClick)="showStats.set(true)" text severity="secondary" class="mx-auto" label="Afficher les statistiques"></p-button>
		<p-button *ngIf="showStats()" icon="pi pi-chevron-up" (onClick)="showStats.set(false)" text severity="secondary" class="mx-auto" pTooltip="Masquer les statistiques"></p-button>
	</div>
</div>

<div *ngIf="EstCharge()">
	<div>
		<p-card styleClass="mt-0 mb-4">
			<div class="flex gap-4 flex-wrap align-items-center">
				<div>
					<button pButton type="button" class="p-button-outlined p-button-secondary"
						(click)="ouvrirDialogueEmplacement()">
						<span *ngIf="!emplacement() || emplacement().length === 0">Sélectionnez un emplacement...</span>
						<span *ngIf="emplacement() && emplacement().length === 1">{{emplacement()[0].nom}}</span>
						<span *ngIf="emplacement() && emplacement().length > 1">{{emplacement().length}} emplacements
							sélectionnés</span>
						<i class="pi pi-chevron-down ml-2"></i>
					</button>
				</div>
	
				<div>
					<button pButton type="button" class="p-button-outlined p-button-secondary"
						[style]="{minWidth: '200px'}" (click)="ouvrirDialogueDepartement()">
						<span *ngIf="!departement() || departement().length == 0">Département...</span>
						<span *ngIf="departement() && departement().length == 1">{{departement()[0].nom}}</span>
						<span *ngIf="departement() && departement().length > 1">{{departement().length}} départements
							sélectionnés</span>
						<i class="pi pi-chevron-down ml-2"></i>
					</button>
				</div>
	
				<div>
					<button pButton type="button" class="p-button-outlined p-button-secondary"
						[style]="{minWidth: '200px'}" (click)="ouvrirDialogueCategorie()">
						<span *ngIf="!categorie() || categorie().length === 0">Catégorie...</span>
						<span *ngIf="categorie() && categorie().length === 1">{{categorie()[0].nom}}</span>
						<span *ngIf="categorie() && categorie().length > 1">{{categorie().length}} catégories
							sélectionnées</span>
						<i class="pi pi-chevron-down ml-2"></i>
					</button>
				</div>

				<div>
					<p-selectButton (onChange)="onFilterChange()" [options]="statuts" [(ngModel)]="statut"
						optionLabel="nom" [allowEmpty]="false">
					</p-selectButton>
				</div>

				<div>
					<button pButton pRipple label="Réinitialiser les filtres" icon="pi pi-filter-slash"
						class="p-button-secondary" (click)="retirerFiltres()"></button>
				</div>
			</div>

		</p-card>

		<p-card styleClass="my-2">
			<div class="flex flex-wrap align-content-center justify-content-between gap-2 mb-2">
				<div class="flex align-items-center flex-wrap gap-2">
					<span class="p-input-icon-left">
						<i class="pi pi-search"></i>
						<input autofocus pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
							placeholder="Recherche..." />
					</span>

					<button *ngIf="estAutorise('commande_ajout_item')" pButton pRipple icon="pi pi-plus" label="Ajouter"
						class="p-button-success" (click)="surAjoutItem()"></button>

					<p-button *ngIf="estAutorise('commande_ajout_item')" text
						icon="pi pi-bars" [label]="'Actions multiples (' + selectionMultipleItemCommande.length + ')'" severity="secondary"
						(click)="surActionsMultiples($event)"></p-button>

				</div>
				<div class="flex align-items-center gap-2">
					<p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="colonnesSelectionneesSignal"
						optionLabel="entete" selectedItemsLabel="{0} colonnes sélectionnés"
						[style]="{minWidth: '200px', marginLeft: '10px'}" placeholder="Colonnes..."></p-multiSelect>
				</div>
			</div>
			<!-- Liste des emplacements des lignes sélectionnées -->
			<div *ngIf="selectionMultipleItemCommande && selectionMultipleItemCommande.length > 0"
				class="flex flex-wrap align-items-center gap-2 mb-2">
				<span class="font-semibold text-sm">Emplacements des lignes sélectionnées:</span>
				<p-tag *ngFor="let emp of getUniqueEmplacementsFromSelection()" [value]="emp.nom" severity="success"
					class="mr-1">
				</p-tag>
			</div>
			<p-table #dt [value]="itemsCommande()" [columns]="selectedColumns" dataKey="itemCommandeId"
				tableStyleClass="tableNormale" [(selection)]="selectionMultipleItemCommande"
				(onRowSelect)="surChangementSelection()" (onRowUnselect)="surChangementSelection()"
				(onHeaderCheckboxToggle)="surChangementSelection()" autoLayout="true"
				styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [filterDelay]="0" [scrollable]="true"
				[globalFilterFields]="['item.numero','item.description','demandeur', 'emplacement.nom', 'emplacement.code', 'statut.nom', 'departement.nom', 'note']" [groupRowsBy]="'emplacement.emplacementId'"
				sortField="dateDemande" sortOrder="-1" [rowGroupMode]="'subheader'">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th style="min-width: 3rem">
							<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
						</th>
						<th pSortableColumn="emplacement.nom">
							<div class="flex justify-content-between align-items-center">
								Emplacement
								<p-sortIcon field="emplacement.nom"></p-sortIcon>
								<p-columnFilter type="text" field="emplacement.nom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th pSortableColumn="quantite">
							<div class="flex justify-content-between align-items-center">
								Qte
								<p-sortIcon field="quantiteDemande"></p-sortIcon>
								<p-columnFilter type="text" field="quantiteDemande" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th pSortableColumn="statut.nom">
							<div class="flex justify-content-between align-items-center">
								Statut
								<p-sortIcon field="statut.nom"></p-sortIcon>
								<p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
									[showOperator]="false" [showAddButton]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
											(onChange)="filter($event.value)" optionLabel="name">
											<ng-template let-option pTemplate="item">
												<div class="multiselect-representative-option">

													<span class="ml-1">{{option.nom}}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.numero">
							<div class="flex justify-content-between align-items-center">
								Numéro
								<p-sortIcon field="item.numero"></p-sortIcon>
								<p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th pSortableColumn="item.description">
							<div class="flex justify-content-between align-items-center">
								Description
								<p-sortIcon field="item.description"></p-sortIcon>
								<p-columnFilter type="text" field="item.description" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('categorie', colonnesSelectionneesSignal)"
							pSortableColumn="item.categorie.nom">
							<div class="flex justify-content-between align-items-center">
								Catégorie
								<p-sortIcon field="item.categorie.nom"></p-sortIcon>
								<p-columnFilter type="text" field="item.categorie.nom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('marque', colonnesSelectionneesSignal)"
							pSortableColumn="item.marque">
							<div class="flex justify-content-between align-items-center">
								Marque
								<p-sortIcon field="item.marque"></p-sortIcon>
								<p-columnFilter type="text" field="item.marque" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('modele', colonnesSelectionneesSignal)"
							pSortableColumn="item.modele">
							<div class="flex justify-content-between align-items-center">
								Modèle
								<p-sortIcon field="item.modele"></p-sortIcon>
								<p-columnFilter type="text" field="item.modele" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th *ngIf="EstColonneSelectionneeSignal('demandeur', colonnesSelectionneesSignal)"
							pSortableColumn="demandeur.prenomNom">
							<div class="flex justify-content-between align-items-center">
								Demandeur
								<p-sortIcon field="demandeur.prenomNom"></p-sortIcon>
								<p-columnFilter type="text" field="demandeur.prenomNom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('dateDemande', colonnesSelectionneesSignal)"
							pSortableColumn="dateDemande">
							<div class="flex justify-content-between align-items-center">
								Date de demande
								<p-sortIcon field="dateDemande"></p-sortIcon>
								<p-columnFilter type="date" field="dateDemande" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('dateRequis', colonnesSelectionneesSignal)"
							pSortableColumn="dateRequis">
							<div class="flex justify-content-between align-items-center">
								Date requise
								<p-sortIcon field="dateRequis"></p-sortIcon>
								<p-columnFilter type="date" field="dateRequis" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('expediteur', colonnesSelectionneesSignal)"
							pSortableColumn="employe.prenomNom">
							<div class="flex justify-content-between align-items-center">
								Expéditeur
								<p-sortIcon field="employe.prenomNom"></p-sortIcon>
								<p-columnFilter type="text" field="employe.prenomNom" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('camion', colonnesSelectionneesSignal)"
							pSortableColumn="camion">
							<div class="flex justify-content-between align-items-center">
								Camion
								<p-sortIcon field="camion"></p-sortIcon>
								<p-columnFilter type="text" field="camion" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('remorque', colonnesSelectionneesSignal)"
							pSortableColumn="remorque">
							<div class="flex justify-content-between align-items-center">
								Remorque
								<p-sortIcon field="remorque"></p-sortIcon>
								<p-columnFilter type="text" field="remorque" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('chauffeur', colonnesSelectionneesSignal)"
							pSortableColumn="chauffeur">
							<div class="flex justify-content-between align-items-center">
								Chauffeur
								<p-sortIcon field="chauffeur"></p-sortIcon>
								<p-columnFilter type="text" field="chauffeur" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('unite', colonnesSelectionneesSignal)"
							pSortableColumn="unite.numero">
							<div class="flex justify-content-between align-items-center">
								Unité
								<p-sortIcon field="unite.numero"></p-sortIcon>
								<p-columnFilter type="text" field="unite.numero" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('codeProjet', colonnesSelectionneesSignal)"
							pSortableColumn="codeProjet.code">
							<div class="flex justify-content-between align-items-center">
								Code projet
								<p-sortIcon field="codeProjet.code"></p-sortIcon>
								<p-columnFilter type="text" field="codeProjet.code" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('codeActivite', colonnesSelectionneesSignal)"
							pSortableColumn="codeActivite.code">
							<div class="pvd-flex justify-content-between align-items-center">
								Code activité
								<p-sortIcon field="codeActivite.code"></p-sortIcon>
								<p-columnFilter type="text" field="codeActivite.code" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('codeCategorie', colonnesSelectionneesSignal)"
							pSortableColumn="codeCategorie.code">
							<div class="flex justify-content-between align-items-center">
								Code catégorie
								<p-sortIcon field="codeCategorie.code"></p-sortIcon>
								<p-columnFilter type="text" field="codeCategorie.code" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('codeEquipement', colonnesSelectionneesSignal)"
							pSortableColumn="codeEquipement.code">
							<div class="flex justify-content-between align-items-center">
								Code équipement
								<p-sortIcon field="codeEquipement.code"></p-sortIcon>
								<p-columnFilter type="text" field="codeEquipement.code" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('departement', colonnesSelectionneesSignal)"
							pSortableColumn="departement">
							<div class="flex justify-content-between align-items-center">
								Département
								<p-sortIcon field="departement"></p-sortIcon>
								<p-columnFilter field="departement" matchMode="in" display="menu"
									[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect [ngModel]="value" [options]="departements" placeholder="Any"
											(onChange)="filter($event.value)" optionLabel="name">
											<ng-template let-option pTemplate="item">
												<div class="multiselect-representative-option">

													<span class="ml-1">{{option.nom}}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</div>
						</th>
						<th *ngIf="EstColonneSelectionneeSignal('note', colonnesSelectionneesSignal)"
							pSortableColumn="note">
							<div class="flex justify-content-between align-items-center">
								Note
								<p-sortIcon field="note"></p-sortIcon>
								<p-columnFilter type="text" field="note" display="menu" class="ml-auto">
								</p-columnFilter>
							</div>
						</th>

						<th pFrozenColumn alignFrozen="right">Actions</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="groupheader" let-rowData let-rowIndex="rowIndex">
					<tr class="p-rowgroup-header">
						<td [attr.colspan]="getTableColspan()">
							<div class="flex align-items-center gap-3">
								<p-checkbox [binary]="true"
									[ngModel]="isEmplacementGroupSelected(rowData.emplacement.nom)"
									(onChange)="toggleEmplacementGroupSelection(rowData.emplacement.nom, $event.checked)"
									pTooltip="Sélectionner/désélectionner tous les items de cet emplacement">
								</p-checkbox>
								<button *ngIf="!filterIsSet(rowData.emplacement)" pButton type="button"
									icon="pi pi-filter" label="Filtrer cet emplacement"
									class="p-button-sm p-button-outlined p-button-secondary"
									(click)="filtrerParEmplacement(rowData.emplacement)"
									pTooltip="Afficher uniquement les items de cet emplacement">
								</button>
								<button *ngIf="filterIsSet(rowData.emplacement)" pButton type="button"
									icon="pi pi-filter-slash" label="Supprimer le filtre"
									class="p-button-sm p-button-outlined p-button-secondary"
									(click)="supprimerFiltreEmplacement(rowData.emplacement)"
									pTooltip="Supprimer le filtre pour cet emplacement">
								</button>
								<i class="pi pi-map-marker"></i>
								<span class="font-bold text-lg">{{rowData.emplacement.nom}}({{getEmplacementItemCount(rowData.emplacement.nom)}})</span>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>

					<tr [pContextMenuRow]="item">
						<td>
							<p-tableCheckbox [value]="item"></p-tableCheckbox>
						</td>
						<td>{{item.emplacement.nom}}</td>
						<td><p-tag [style]="{whiteSpace: 'nowrap'}">{{item.quantite}} / {{item.quantiteDemande}}</p-tag>
						</td>
						<td><span [class]="'statut ' + getStatutCssClass(item.statut.nom)">
								{{item.statut.nom}}
							</span>
						</td>

						<td>
							<div class="flex align-items-center gap-2">
								<span *ngIf="hasMultipleLines(item.item.description)" 
									class="groupe-item-dot"
									[style.background-color]="getCouleurPourNumero(item.item.description)"
									[pTooltip]="'Cet item apparaît sur plusieurs lignes'">
								</span>
								<span>{{item.item.numero}}</span>
							</div>
						</td>
						<td>{{item.item.description}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('categorie', colonnesSelectionneesSignal)">
							{{item.item.categorie?.nom}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('marque', colonnesSelectionneesSignal)">
							{{item.item.marque}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('modele', colonnesSelectionneesSignal)">
							{{item.item.modele}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('demandeur', colonnesSelectionneesSignal)">
							<app-employe-avec-emplacement [employe]="item.demandeur"></app-employe-avec-emplacement>
						</td>
						<td *ngIf="EstColonneSelectionneeSignal('dateDemande', colonnesSelectionneesSignal)">
							{{item.dateDemande | date:'yyyy-MM-dd'}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('dateRequis', colonnesSelectionneesSignal)"
							[style.color]="isDateRequisExpired(item.dateRequis) ? 'red' : 'inherit'">
							{{item.dateRequis | date:'yyyy-MM-dd'}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('expediteur', colonnesSelectionneesSignal)">
							<app-employe-avec-emplacement [employe]="item.employe"></app-employe-avec-emplacement></td>
						<td *ngIf="EstColonneSelectionneeSignal('camion', colonnesSelectionneesSignal)">{{item.camion}}
						</td>
						<td *ngIf="EstColonneSelectionneeSignal('remorque', colonnesSelectionneesSignal)">
							{{item.remorque}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('chauffeur', colonnesSelectionneesSignal)">
							{{item.chauffeur}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('unite', colonnesSelectionneesSignal)">
							{{item.unite?.numero}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('codeProjet', colonnesSelectionneesSignal)">
							{{item.codeProjet?.code}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('codeActivite', colonnesSelectionneesSignal)">
							{{item.codeActivite?.code}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('codeCategorie', colonnesSelectionneesSignal)">
							{{item.codeCategorie?.code}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('codeEquipement', colonnesSelectionneesSignal)">
							{{item.codeEquipement?.code}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('departement', colonnesSelectionneesSignal)">
							{{item.departement?.nom}}</td>
						<td *ngIf="EstColonneSelectionneeSignal('note', colonnesSelectionneesSignal)" style="word-wrap: break-word; max-width: 500px;">
								{{item.note}}
						</td>
						<td pFrozenColumn alignFrozen="right">
							<div class="flex align-items-center gap-1">
								<button pButton pRipple icon="pi pi-bars" class="p-button-secondary mr-2 boutonGrille"
									(click)="surMenuContextuelItem($event, item)"></button>
								<button *ngIf="estAutorise('commande_supprimer_item')" pButton pRipple
									icon="pi pi-trash" class="p-button-danger mr-2 boutonGrille"
									(click)="supprimerItems([item])"></button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td [attr.colspan]="colonnesSelectionneesSignal().length + 7">
							<div class="flex flex-column justify-content-center align-items-center gap-2 p-4">
								<i class="pi pi-info-circle text-2xl text-gray-500"></i>
								<span class="text-lg text-gray-500">Aucun item.</span>
								<small class="text-gray-500">
									Utilisez les filtres pour afficher les items.
								</small>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>


		</p-card>
	</div>


</div>
<!-- Dialog for Emplacement Selection -->
<p-dialog header="Sélectionnez les emplacements" [(visible)]="afficherDialogueEmplacement" dismissableMask
	[style]="{width: isMobile ? '90vw' : '700px'}" [modal]="true" [closable]="true">
	<p-listbox *ngIf="afficherDialogueEmplacement" [options]="emplacements" [(ngModel)]="emplacement" optionLabel="nom" [multiple]="true"
		scrollHeight="60vh" [style]="{width: '100%'}" [filter]="true" filterBy="code,nom" (onChange)="onFilterChange()"
		filterPlaceHolder="Rechercher...">
		<ng-template let-option pTemplate="item">
			<div class="flex align-items-center gap-4 justify-content-between w-full">
				<div class="flex align-items-center gap-2">
					<i class="pi pi-map-marker"></i>
					<div class="flex flex-column">
						<span class="ml-1">{{option.code}}</span>
						<span class="ml-1 font-bold">{{option.nom}}</span>
					</div>
				</div>
				<div class="flex align-items-center justify-content-end gap-2">
					@for (statut of statuts; track statut.statutId) {
					<span *ngIf="getStatutCountForEmplacement(option, statut) > 0" [class]="'statut ' + getStatutCssClass(statut.nom)" [pTooltip]="statut.nom">{{getStatutCountForEmplacement(option, statut)}}</span>
					}
				</div>
			</div>
		</ng-template>
	</p-listbox>
	<ng-template pTemplate="footer">
		<button pButton type="button" label="Fermer" class="p-button-text"
			(click)="fermerDialogueEmplacement(false)"></button>
	</ng-template>
</p-dialog>

<!-- Dialog for Departement Selection -->
<p-dialog header="Sélectionnez les départements" [(visible)]="afficherDialogueDepartement" dismissableMask
	[style]="{width: isMobile ? '90vw' : '600px'}" [modal]="true" [closable]="true">
	<p-listbox [options]="departements" [(ngModel)]="departement" optionLabel="nom" [multiple]="true"
		scrollHeight="60vh" [style]="{width: '100%'}" [filter]="true" filterBy="nom" (onChange)="onFilterChange()"
		filterPlaceHolder="Rechercher...">
		<ng-template let-option pTemplate="item">
			<div class="flex align-items-center gap-2">
				<i *ngIf="option.employeId" class="pi pi-user"></i>
				<i *ngIf="!option.employeId" class="pi pi-building"></i>
				<span class="ml-1">{{option.nom}}</span>
			</div>
		</ng-template>
	</p-listbox>
	<ng-template pTemplate="footer">
		<button pButton type="button" label="Fermer" class="p-button-text"
			(click)="fermerDialogueDepartement(false)"></button>
	</ng-template>
</p-dialog>

<!-- Dialog for Catégorie Selection -->
<p-dialog header="Sélectionnez les catégories" [(visible)]="afficherDialogueCategorie" dismissableMask
	[style]="{width: isMobile ? '90vw' : '600px'}" [modal]="true" [closable]="true">
	<p-listbox [options]="categories" [(ngModel)]="categorie" optionLabel="nom" [multiple]="true" scrollHeight="60vh"
		[style]="{width: '100%'}" [filter]="true" filterBy="nom" filterPlaceHolder="Rechercher..."
		(onChange)="onFilterChange()">
		<ng-template let-option pTemplate="item">
			<div class="flex align-items-center gap-2">
				<i class="pi pi-tag"></i>
				<span class="ml-1">{{option.nom}}</span>
			</div>
		</ng-template>
	</p-listbox>
	<ng-template pTemplate="footer">
		<button pButton type="button" label="Fermer" class="p-button-text"
			(click)="fermerDialogueCategorie(false)"></button>
	</ng-template>
</p-dialog>

<!-- Dialog for Commandes Actives Management -->
<p-dialog header="Gestion des commandes actives" [(visible)]="afficherDialogueCommandesActives" dismissableMask
	[style]="{width: isMobile ? '90vw' : '800px'}" [modal]="true" [closable]="true">
	<div class="mb-3">
		<p class="text-600">Sélectionnez les emplacements pour lesquels les commandes seront disponibles dans le
			système.</p>
	</div>

	<p-dataView [value]="tousLesEmplacements" layout="grid" class="overflow-y-auto" [style]="{height: '500px'}">
		<ng-template pTemplate="gridItem" let-emplacements>
			<div class="grid overflow-y-auto" style="height: 50vh;">
				@for (emplacement of emplacements; track emplacement.emplacementId) {
				<div class="col-12 md:col-6 lg:col-4 mb-2">
					<p-card styleClass="h-full">
						<div class="flex align-items-center gap-3">
							<p-checkbox [(ngModel)]="emplacement.commandeActive" [binary]="true"
								[inputId]="'emplacement-' + emplacement.emplacementId">
							</p-checkbox>
							<div class="flex flex-column flex-1">
								<label [for]="'emplacement-' + emplacement.emplacementId"
									class="font-semibold cursor-pointer">
									{{emplacement.code}}
								</label>
								<small class="text-600">{{emplacement.nom}}</small>
							</div>
							<div class="flex align-items-center">
								<i class="pi pi-map-marker text-blue-500"></i>
							</div>
						</div>
					</p-card>
				</div>
				}
			</div>
		</ng-template>
	</p-dataView>

	<ng-template pTemplate="footer">
		<div class="flex justify-content-between">
			<button pButton type="button" label="Annuler" class="p-button-text"
				(click)="fermerDialogueCommandesActives()"></button>
			<button pButton type="button" label="Sauvegarder" class="p-button-success"
				(click)="sauvegarderCommandesActives()"></button>
		</div>
	</ng-template>
</p-dialog>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>

		</p-card>
	</div>
</div>